<template>
  <div class="glPage">
    <!-- 顶部品牌化头部 -->
    <div class="glHeader">
      <i class="glBack" @click="goBack"></i>
      <span class="glTitle">{{ cateName }}</span>
    </div>

    <!-- 搜索 -->
    <div class="glSearch">
      <van-search v-model="searchKey" shape="round" background="transparent" placeholder="搜索游戏名称" />
    </div>

    <!-- 顶部 TAB -->
    <div class="glTabs">
      <div :class="activeTab == 'all' ? 'glTab on' : 'glTab'" @click="changeTab('all')">全部</div>
      <div :class="activeTab == 'hot' ? 'glTab on' : 'glTab'" @click="changeTab('hot')">热门</div>
      <div :class="activeTab == 'recent' ? 'glTab on' : 'glTab'" @click="changeTab('recent')">最近</div>
    </div>

    <!-- 主体：左厂商侧栏 + 右游戏 -->
    <div class="glBody">
      <!-- 左侧同类厂商切换 -->
      <div class="glRail">
        <div v-for="(v, vi) in vendors" :key="vi" :class="v.platform_name == platform ? 'rItem on' : 'rItem'" @click="switchVendor(v)">
          <div class="rIcon"><img :src="xhLogo(v.platform_name)" @error="onIconErr($event, v)" alt="" /></div>
          <p>{{ v.name }}</p>
        </div>
      </div>

      <!-- 右侧游戏网格 -->
      <div class="glMain">
        <!-- 骨架屏：加载态占位，避免整屏卡在"加载中" -->
        <div v-if="isLoading" :class="isArtCate ? 'gameList artGrid' : 'gameList'">
          <div :class="isArtCate ? 'gameLis artTile skTile' : 'gameLis skTile'" v-for="n in (isArtCate ? 8 : 12)" :key="'sk' + n">
            <div class="skImg"></div>
            <div class="skTxt"></div>
          </div>
        </div>
        <!-- 真实游戏列表 -->
        <div :class="isArtCate ? 'gameList artGrid' : 'gameList'" v-else-if="displayList.length > 0">
          <div :class="isArtCate ? 'gameLis artTile' : 'gameLis'" v-for="(item, index) in displayList" :key="index" @click="openGame(item)">
            <img :src="gamePic(item, index)" @error="onGameImgErr($event, item)" alt="" />
            <p>{{ item.gamename }}</p>
          </div>
        </div>
        <div v-else class="glEmpty">{{ emptyText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
// 会话级子游戏缓存（同一分类+厂商再次进入瞬开，避免重复等待接口）
const subgameCache = {};
export default {
  name: 'gamelist',
  data() {
    return {
      platform: '',
      cate: '',
      title: '',
      searchKey: '',
      activeTab: 'all',
      allList: [],
      hotList: [],
      recentList: [],
      recentLoaded: false,
      loaded: false,
      cateLabels: {
        concise: '电子',
        joker: '棋牌',
        fishing: '捕鱼',
        realbet: '真人',
        sport: '体育',
        gaming: '电竞',
        lottery: '彩票',
      },
    };
  },
  created() {
    this.ensureVendors();
    this.initFromQuery();
  },
  computed: {
    cateName() {
      return this.cateLabels[this.cate] || this.title || '游戏列表';
    },
    // 当前分类下的同类厂商（用于左侧切换栏）
    vendors() {
      return this.$store.state[this.cate + 'List'] || [];
    },
    // 当前 TAB 的基础列表
    baseList() {
      if (this.activeTab == 'hot') return this.hotList;
      if (this.activeTab == 'recent') return this.recentList;
      return this.allList;
    },
    // 叠加搜索过滤
    displayList() {
      let key = (this.searchKey || '').trim().toLowerCase();
      if (!key) return this.baseList;
      return this.baseList.filter(g => (g.gamename || '').toLowerCase().indexOf(key) > -1);
    },
    // 体育类子游戏图源是单张通用图，复用首页 3D 美术图做高级卡
    isArtCate() {
      return this.cate === 'sport';
    },
    // 当前 TAB 是否处于加载态（用于决定显示骨架屏）
    isLoading() {
      if (this.activeTab == 'recent') {
        return !!this.$store.state.token && !this.recentLoaded;
      }
      return !this.loaded;
    },
    emptyText() {
      if (this.activeTab == 'recent') {
        if (!this.$store.state.token) return '登录后查看最近玩过的游戏';
        return '暂无最近游戏记录';
      }
      if (this.searchKey) return '没有搜到相关游戏';
      return '暂无游戏';
    },
  },
  methods: {
    goBack() {
      // 直接回首页，避免历史栈里夹着落地页跳转导致返回失败
      this.$router.replace('/');
    },
    // 侧栏为空时（直达/刷新）尝试补数据
    ensureVendors() {
      if (this.vendors && this.vendors.length > 0) return;
      this.$store.commit('changGameList'); // 先从 localStorage 灌
      if ((this.$store.state[this.cate + 'List'] || []).length == 0 && this.$parent.getGameList) {
        this.$parent.getGameList(); // 仍空则拉接口，store 更新后侧栏自动刷新
      }
    },
    initFromQuery() {
      let q = this.$route.query;
      this.platform = q.platform || '';
      this.cate = q.cate || '';
      this.title = q.title ? decodeURIComponent(q.title) : '';
      this.searchKey = '';
      this.activeTab = 'all';
      this.recentLoaded = false;
      this.recentList = [];
      this.getSubgames();
    },
    getSubgames() {
      let that = this;
      if (!that.platform || !that.cate) return;
      let key = that.platform + '|' + that.cate;
      // 命中会话缓存：瞬间渲染，再后台静默刷新（丝滑，无加载遮罩）
      if (subgameCache[key] && subgameCache[key].length) {
        that.allList = subgameCache[key];
        that.hotList = that.pickHot(that.allList);
        that.loaded = true;
        that.fetchSubgames(key, true);
        return;
      }
      // 无缓存：清空 + 交给骨架屏占位（不再用全屏"加载中"遮罩）
      that.allList = [];
      that.hotList = [];
      that.loaded = false;
      that.fetchSubgames(key, false);
    },
    fetchSubgames(key, silent) {
      let that = this;
      that.$apiFun
        .post('/api/subgamesByPlatform', { platform_name: that.platform, category_id: that.cate })
        .then(res => {
          if (res.code == 200) {
            let data = res.data || [];
            subgameCache[key] = data;
            // 仅当仍停留在同一分类时回填，避免快速切换导致错位
            if (key === that.platform + '|' + that.cate) {
              that.allList = data;
              that.hotList = that.pickHot(data);
            }
          } else if (!silent) {
            that.$parent.showTost(0, res.message);
          }
          that.loaded = true;
        })
        .catch(() => {
          that.loaded = true;
        });
    },
    getRecent() {
      let that = this;
      if (!that.platform || !that.cate) return;
      if (!that.$store.state.token) {
        that.recentLoaded = true;
        return;
      }
      that.$apiFun
        .post('/api/recentGamesByPlatform', { platform_name: that.platform, category_id: that.cate })
        .then(res => {
          if (res.code == 200) {
            that.recentList = res.data || [];
          }
          that.recentLoaded = true;
        })
        .catch(() => {
          that.recentLoaded = true;
        });
    },
    // 从全量里随机抽 ~12 款作为热门
    pickHot(list) {
      let arr = (list || []).slice();
      for (let i = arr.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let t = arr[i];
        arr[i] = arr[j];
        arr[j] = t;
      }
      return arr.slice(0, 12);
    },
    changeTab(tab) {
      this.activeTab = tab;
      if (tab == 'recent' && !this.recentLoaded) {
        this.getRecent();
      }
    },
    // 原地切换同类厂商
    switchVendor(v) {
      if (!v || v.platform_name == this.platform) return;
      this.$router.replace({
        path: '/gamelist',
        query: { platform: v.platform_name, cate: v.category_id || this.cate, title: v.name || '' },
      });
      // 路由 query 变化触发 watch->initFromQuery 重新加载
    },
    openGame(item) {
      this.$parent.openGamePage(item.catecode, item.gamecode, item.gametype);
    },
    // 体育：用首页同款 3D 美术图（按厂商错开取图），其余分类用原厂图源
    gamePic(item, index) {
      if (this.cate === 'sport') {
        var baseMap = { IM: 1, IBC: 2, HG: 3 };
        var base = baseMap[this.platform] || 1;
        var n = ((base - 1 + index) % 5) + 1;
        return '/static/vendorart/sport_' + n + '.webp';
      }
      // 真人 AG视讯 星汇 ZH 目录缺图，EN 目录多数存在 → 优先取 EN
      if (this.cate === 'realbet') {
        return (item.gamepic || '').replace('/ZH/', '/EN/');
      }
      return item.gamepic;
    },
    // 子游戏图加载失败兜底：ZH→EN 再试一次；仍失败用厂商大厅主图（星汇部分子游戏无独立图）
    onGameImgErr(e, item) {
      var el = e.target;
      var s = el.getAttribute('src') || '';
      if (!el.dataset.s1 && s.indexOf('/ZH/') > -1) {
        el.dataset.s1 = '1';
        el.src = s.replace('/ZH/', '/EN/');
        return;
      }
      if (!el.dataset.s2 && this.platform && /xh-img\.com/.test(s)) {
        el.dataset.s2 = '1';
        el.src = 'https://alicdn.xh-img.com/uploads/images/maingame/m1/live/' + this.platform + '.webp';
        return;
      }
      if (!el.dataset.s3) {
        el.dataset.s3 = '1';
        // 星汇该子游戏无任何独立图（ZH/EN/大厅全 404）→ 用品牌占位图，展示游戏名，避免露出生硬 logo
        el.src = this.placeholderImg(item && item.gamename);
      }
    },
    // 生成酒红金品牌占位图（内联 SVG，永不 404），缺图游戏显示游戏名而非厂商 logo
    placeholderImg(name) {
      var t = (name == null ? '' : String(name)).trim();
      if (t.length > 6) t = t.slice(0, 6);
      t = t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var svg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">' +
        '<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">' +
        '<stop offset="0" stop-color="#4a0e22"/><stop offset="0.55" stop-color="#641530"/><stop offset="1" stop-color="#7a1330"/>' +
        '</linearGradient></defs>' +
        '<rect width="200" height="200" fill="url(#g)"/>' +
        '<text x="100" y="78" font-size="40" fill="#e6c877" text-anchor="middle" font-family="serif">&#9670;</text>' +
        '<text x="100" y="132" font-size="26" fill="#f6e3ab" text-anchor="middle" font-family="sans-serif" font-weight="bold">' + t + '</text>' +
        '<text x="100" y="166" font-size="13" fill="#c69a3f" text-anchor="middle" font-family="sans-serif" letter-spacing="3">XIN JIN JIANG</text>' +
        '</svg>';
      return 'data:image/svg+xml,' + encodeURIComponent(svg);
    },
    xhLogo(code) {
      return 'https://alicdn.xh-img.com/uploads/images/gamelogo/' + code + 'LOGO.webp';
    },
    localVendorImg(v) {
      return v.mobile_img || v.api_logo_img || v.app_img || v.game_icon || '';
    },
    onIconErr(e, v) {
      // XH logo 加载失败 → 回退本地 logo（一次，避免死循环）
      let el = e.target;
      if (el.dataset.fb) return;
      el.dataset.fb = '1';
      el.src = this.localVendorImg(v);
    },
  },
  watch: {
    $route: {
      handler() {
        this.initFromQuery();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.glPage {
  width: 100%;
  min-height: 100vh;
  background: #f7f8fa;
}
.glHeader {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: linear-gradient(180deg, #fffdf8 0%, #ffffff 100%);
  border-bottom: 1px solid rgba(201, 163, 90, 0.35);
  box-shadow: 0 2px 10px rgba(180, 140, 60, 0.1);
  .glBack {
    position: absolute;
    left: 14px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-left: 2px solid #b98f43;
    border-bottom: 2px solid #b98f43;
    transform: translateY(-50%) rotate(45deg);
  }
  .glTitle {
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #9a7b3f;
  }
}
.glSearch {
  padding: 6px 6px 0;
  background: #f7f8fa;
  ::v-deep .van-search__content {
    background: #fff;
    border: 1px solid #eef0f3;
  }
}
.glTabs {
  display: flex;
  padding: 4px 10px 8px;
  background: #f7f8fa;
  .glTab {
    padding: 6px 18px;
    margin-right: 10px;
    font-size: 13px;
    color: #64748b;
    background: #fff;
    border: 1px solid #eef0f3;
    border-radius: 16px;
  }
  .glTab.on {
    color: #fff;
    background: linear-gradient(135deg, #e6c877, #c69a3f);
    border-color: transparent;
    font-weight: 600;
    box-shadow: 0 3px 8px rgba(198, 154, 63, 0.3);
  }
}
// 单滚动条：去掉两栏各自 overflow，整页滚动；左厂商栏 sticky 保持可见
.glBody {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
}
.glRail {
  width: 76px;
  flex: 0 0 76px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  align-self: flex-start;
  padding: 4px 6px 12px;
  box-sizing: border-box;
  .rItem {
    text-align: center;
    padding: 8px 2px;
    margin-bottom: 6px;
    background: #fff;
    border-radius: 10px;
    .rIcon {
      width: 40px;
      height: 40px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
        display: block;
      }
    }
    p {
      font-size: 10px;
      color: #64748b;
      margin: 4px 0 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .rItem.on {
    background: linear-gradient(135deg, #e6c877, #c69a3f);
    box-shadow: 0 4px 10px rgba(198, 154, 63, 0.32);
    p {
      color: #fff;
      font-weight: 700;
    }
  }
}
.glMain {
  flex: 1;
  padding-bottom: 20px;
  box-sizing: border-box;
  .gameList {
    display: flex;
    flex-wrap: wrap;
    width: 96%;
    margin: 4px auto;
    .gameLis {
      position: relative;
      width: calc(33.33% - 8px);
      margin-right: 8px;
      margin-top: 8px;
      cursor: pointer;
      img {
        display: block;
        width: 100%;
        /* XH 子游戏图源比例不统一(1:1 方图 / 5:3 或 3:2 横图混排)，
           统一成固定 4:3 box + cover 裁切，保证整格视觉一致 */
        aspect-ratio: 4 / 3;
        object-fit: cover;
        background: #f1f5f9;
        border-radius: 10px;
      }
      p {
        text-align: center;
        font-size: 11px;
        color: #475569;
        margin: 3px 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  // 体育：3D 美术图高级卡（2 列，深色底 + 金边），复用首页素材
  .gameList.artGrid {
    width: 96%;
    margin: 4px auto;
    .gameLis.artTile {
      width: calc(50% - 8px);
      img {
        aspect-ratio: 1 / 1;
        object-fit: contain;
        object-position: bottom;
        background: linear-gradient(180deg, #1b2138 0%, #0d1224 100%);
        border: 1px solid rgba(217, 180, 91, 0.3);
        box-shadow: 0 6px 16px rgba(16, 24, 40, 0.12);
        padding: 2px 6px 0;
        box-sizing: border-box;
      }
      p {
        font-weight: 700;
        color: #0f172a;
      }
    }
  }
  .glEmpty {
    text-align: center;
    color: #999;
    padding: 50px 0;
    font-size: 13px;
  }
  // 骨架屏占位（微光扫过），让点击进入瞬间有内容框架、无空屏卡顿
  .skTile {
    pointer-events: none;
    .skImg {
      width: 100%;
      aspect-ratio: 4 / 3;
      border-radius: 10px;
      background: #e9edf2;
      position: relative;
      overflow: hidden;
    }
    .skTxt {
      height: 10px;
      width: 68%;
      margin: 7px auto 0;
      border-radius: 5px;
      background: #e9edf2;
      position: relative;
      overflow: hidden;
    }
    .skImg::after,
    .skTxt::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transform: translateX(-100%);
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.75), transparent);
      animation: glShimmer 1.15s ease-in-out infinite;
    }
    &.artTile .skImg {
      aspect-ratio: 1 / 1;
    }
  }
}
@keyframes glShimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamelist.vue